import type { PropsWithChildren } from "react";
import type { Props } from "./FundraisingsPageContext";
import { FundraisingsPageContext } from "./FundraisingsPageContext";

export const FundraisingsPageContextProvider = ({
  hasEditPermissions,
  onCreate,
  onRename,
  onStatusChange,
  onDelete,
  children,
}: PropsWithChildren<Props>) => (
  <FundraisingsPageContext value={{ hasEditPermissions, onCreate, onRename, onStatusChange, onDelete }}>
    {children}
  </FundraisingsPageContext>
);
